import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 20 19.62",
  "content": "<symbol viewBox=\"0 0 20 19.62\" id=\"filter\"><title>filter</title><path d=\"M13.76,8.25,17.61,3.9l2.15-2.44A.67.67,0,0,0,20,1a.73.73,0,0,0-.19-.55A1.12,1.12,0,0,0,19,.2H1C.36.19.18.42.07.66a.87.87,0,0,0,.25,1l2.76,3L6.33,8.31A1.77,1.77,0,0,1,6.8,9.58c0,1.27,0,2.54,0,3.81s0,2.26,0,3.38a.72.72,0,0,0,.46.79l2.13.95,2.68,1.19a.8.8,0,0,0,.73,0,.83.83,0,0,0,.28-.7c.08-2.91.17-6.29.24-9.64A1.67,1.67,0,0,1,13.76,8.25Zm-1.61,2.17c-.1,2.25-.2,4.57-.29,6.85a.82.82,0,0,1-.32.72.57.57,0,0,1-.29.08,1.11,1.11,0,0,1-.49-.15c-.62-.31-1.28-.63-2-.93A1.11,1.11,0,0,1,8,15.86c0-2.15,0-3.92,0-5.6a1,1,0,0,1,.26-.78,1,1,0,0,1,.79-.21c.22,0,.45,0,.69,0h1.55a.82.82,0,0,1,.63.22.79.79,0,0,1,.2.61Zm4.35-7.07-.34.37c-.57.66-1.15,1.31-1.73,2s-1,1.18-1.56,1.77A1.53,1.53,0,0,1,11.65,8h0c-.76,0-1.53,0-2.27,0H8.46a1.14,1.14,0,0,1-.95-.32L3.65,3.42,2,1.58l15.95.09Z\" transform=\"translate(0 -0.19)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/filter.svg
// module id = PTMJ
// module chunks = 264